<template>
  <div class="menuWrapper">
    <div class="main2-content" id="menuPapel" :class="canFixed ? 'indfixed' : 'indnormal'">
      <div class="panel-content">
        <div class="roll-content">
          <!-- 已移除左右箭头按钮 -->
          <div class="width-roll">
            <div class="menu-container">
              <div class="menu" v-for="(item, index) in menu" :key="index" :style="{
                  color: index == btnIndex ? item.color : '',
                }"
                   @click="handleMenu(index)">
                <div class="btn">
                  <div>{{ item.name }}</div>
                  <div>{{ item.nameEn }}</div>
                </div>
                <div class="bottom" v-show="index === btnIndex">
                  <img src="../../assets/image/esg/sceneMenu.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config1";
import { throttle } from 'lodash';
export default {
  components: {},
  data() {
    return {
      ...config,
      btnIndex: null,
      menu: [
        {
          name: "臻品卓越",
          nameEn: "Exceptional Quality",
          to: "",
          color: "#C39A6B",
        },
        {
          name: "气候变化",
          nameEn: "Climate Change",
          to: "",
          color: "#12A79D",
        },
        {
          name: "守护生态环境",
          nameEn: "Protecting the Ecological Environment",
          to: "",
          color: "#12A79D",
        },
        {
          name: "共筑和谐社会",
          nameEn: "Contribute to a Harmonious Society",
          to: "",
          color: "#C39A6B",
        },
        {
          name: "稳健公司治理",
          nameEn: "Robust Corporate Governance",
          to: "",
          color: "#144E82",
        }
      ],
      toScrollTop: 0, // 滚动高度
      bannerOffsetTop:0,//banner到頂部的高度
      esgMenuHeight:0, //导航栏的高度
      isScrolling: false // 新增：表示是否正在由点击触发滚动
    };
  },
  computed: {
    canFixed() {
      if (this.toScrollTop >= this.bannerOffsetTop && this.toScrollTop > 0) {
        console.log('菜单可以fix在顶部',this.toScrollTop,this.bannerOffsetTop)
        return true;
      } else {
        console.log('菜单在文档流',this.toScrollTop,this.bannerOffsetTop)
        return false;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      // Vue组件渲染完成后立即执行的操作
      window.addEventListener('load', this.finalInit);
    })
  },
  methods: {
    finalInit() {
      this.toScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      this.initScrollSpy()
      window.onscroll = throttle(() => {
        this.toScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        this.onScroll();
      }, 100);
    },
    initScrollSpy() {
      // 1. 获取 banner 高度（考虑缩放）
      const bannerBg = document.getElementById("bannerBg");
      if (!bannerBg) return;
      // 获取导航栏
      const menuPapel = document.querySelector("#menuPapel");
      if (!menuPapel) return;

      const scaleMap = {
        1.5: 0.7,
        1.25: 0.78,
        1: 1
      };
      const scale = scaleMap[window.devicePixelRatio] || 1;

      // 导航栏的高度
      this.esgMenuHeight = menuPapel.clientHeight * scale;
      //banner到頂部的高度
      this.bannerOffsetTop = bannerBg.clientHeight * scale + 110*scale;
      console.log('scale', scale)
      console.log('导航栏的高度',this.esgMenuHeight,'banner的高度',bannerBg.clientHeight,'banner到頂部的高度',this.bannerOffsetTop)


      // 首次触发高亮
      this.onScroll();
    },

    onScroll() {
      if (this.isScrolling) return; // 如果是点击触发的滚动，跳过处理

      const scrollY = window.scrollY;
      const current = scrollY + this.esgMenuHeight + 10; // +10 避免临界抖动

      // 动态获取所有 section 的 top（避免使用缓存）
      const sections = [];
      for (let i = 0; i < this.menu.length; i++) {
        const el = document.querySelector(`#scene${i + 1}`);
        if (el) {
          const rect = el.getBoundingClientRect();
          const top = rect.top + window.scrollY; // 当前实际 top
          sections.push({ id: i, top });
        }
      }

      console.log('滚动事件',sections)

      let activeIndex = 0;
      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        const nextSection = sections[i + 1];

        if (!nextSection) {
          // 最后一个区块：只要超过它的 top 就选它
          activeIndex = i;
          break;
        }

        // 当前滚动位置在 [section.top, nextSection.top) 区间内
        if (current >= section.top && current < nextSection.top) {
          activeIndex = i;
          break;
        }
      }

      // 防止频繁更新（可选）
      if (this.btnIndex !== activeIndex) {
        this.btnIndex = activeIndex;
      }
    },
    handleMenu(index) {
      const element = document.querySelector("#scene" + (index + 1));
      if (!element) return;

      // 1. 禁用滚动监听
      this.isScrolling = true;
      // 2. 记录目标 index，避免后续 onScroll 干扰
      this.btnIndex = index;

      // 3. 滚动到目标位置
      const elementTop = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementTop-this.esgMenuHeight,
        behavior: "smooth"
      });
      // 4. 滚动结束后恢复监听（使用 setTimeout）
      setTimeout(() => {
        this.isScrolling = false;
      }, 500); // 延迟时间略大于动画时长（默认 smooth 是 400ms）

    }
  },
};
</script>

<style lang="less" scoped>
@import url("./common.less");
.menuWrapper{
  height: 80px;
}
.main2-content{
  background: #ffffff;height: 80px;
  &.indfixed{
    position: fixed;top: 0;left: 0;right: 0;top: 0px; z-index: 10000;
  }
  &.indnormal{
    position: relative;
  }
}
// 新增菜单容器样式
.menu-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.menu {
  color: #333333;
  text-align: center;
  padding: 16px 0 9px;
  cursor: pointer;
  /* 关键属性：等宽分布 */
  margin: 0 5px;

  .btn {
    // transform: skewX(45deg);
  }

  .bottom {
    img {
      margin-top: 4px;
      height: 20px;
      width: auto;
    }
  }
}

.panel-content {
  padding: 0px 8%;
  background: #fff;
}

.roll-content {
  position: relative;
  // max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  .width-roll {
    width: 100%;
    /* 自适应宽度 */
  }
}

/* 删除原有的 .roll-icon-left 和 .roll-icon-right 样式 */
</style>